import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllProfilesPageSize = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<'10' | '25' | '50' | '100'>((state, action) => {
    state.allProfiles.pageSize = action.payload;
  });
